const ZohoDeskEmbedded = {
  loadScripts: function () {
    return new Promise((resolve, reject) => {
      resolve("");
    });
  },
  init: function (setAppProperties) {
    return new Promise((resolve, reject) => {
      resolve(initializeZohoDesk(setAppProperties));
    });
  },
  showCallNotification: function (zohoDeskAppInstance, callState, setAppProperties) {
    return new Promise((resolve, reject) => {
      if (zohoDeskAppInstance?.location) window?.ZOHODESK?.invoke("SHOW");
      window?.ZOHODESK?.invoke("RESIZE", {
        height: "100%",
      });
    });
  },
  hideCallNotification: function (pipedriveSDK) {
    return new Promise((resolve, reject) => {
      window?.ZOHODESK?.invoke("HIDE");
    });
  },
  getUserData: async function (isUserHashNeeded) {
    const userData = await getUserDataFromLocalStorage();

    if (isUserHashNeeded) {
      userData["userHash"] = await this.getApplicationToken(userData?.["userId"]);
    }
    return new Promise((resolve, reject) => {
      resolve(userData);
    });
  },
  getFilterObjectForShrinkView: function () {
    return new Promise((resolve, reject) => {
      resolve({});
    });
  },
  get: function (key) {
    return new Promise((resolve, reject) => {
      window.ZOHO.CRM.API.getOrgVariable(key)
        .then(function (response) {
          if (typeof response == "string") {
            response = JSON.parse(response);
          }
          var successResp = response.Success;
          if (typeof successResp == "string") {
            successResp = JSON.parse(successResp);
          }

          var contentObj = successResp?.Content;
          if (contentObj) {
            resolve(contentObj);
          } else {
            resolve("");
          }
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },
  openRecord: function (sdk, id, module) {
    return new Promise((resolve, reject) => {
      window?.ZOHODESK?.invoke("ROUTE_TO", {
        entity: "ticket",
        id: id,
        page: "dv",
      });
    });
  },
  populateRecord: function (sdk, id, module, phone) {
    return new Promise((resolve, reject) => {
      resolve();
    });
  },
  fetchContact: function (fetchData, appProperties, phoneFieldConfiguration) {
    return new Promise((resolve, reject) => {
      if (!window?.ZOHODESK?.get) {
        console.error("ZOHODESK API not available");
        return;
      }
      window.ZOHODESK.get("ticket").then(async (res) => {
        try {
          const ticketObj = res.ticket;
          const responseFinal = await fetchContactFromZohoDesk(fetchData, appProperties, phoneFieldConfiguration, ticketObj);
          resolve(responseFinal);
        } catch (error) {
          console.error("Error in fetchContact:", error);
        }
      });
    });
  },
  getAssociatedObjectId: function (appProperties) {
    return new Promise((resolve, reject) => {
      try {
        const { ZOHODESK } = window || {};
        const location = appProperties?.loadedSDK?.location || "";

        if (!ZOHODESK || !location) {
          return resolve("");
        }

        const idKey = location.includes("ticket") ? "ticket.id" : location.includes("contact") ? "contact.id" : null;

        if (!idKey) {
          return resolve("");
        }

        ZOHODESK.get(idKey)
          .then((response) => resolve(response[idKey] || ""))
          .catch(reject);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAssociatedObjectType: async function (appProperties) {
    const location = appProperties?.loadedSDK?.location || "";
    if (!window?.ZOHODESK || !location) return "";

    if (location.includes("ticket")) {
      return "tickets";
    }
    if (location.includes("contact") || location.includes("contacts")) {
      return "contacts";
    }
    return "";
  },
  insertContent: function (resultAreaInput) {
    return new Promise((resolve, reject) => {
      window?.ZOHODESK?.invoke("INSERT", "ticket.replyEditor", {
        value: resultAreaInput,
      });
      resolve();
    });
  },
  getFields: function (module, appProperties) {
    return new Promise((resolve, reject) => {
      const zohoDeskUrl = appProperties?.zohoDeskUrl ?? "https://desk.zoho.com";
      let fieldsRequestObj = {
        url: `${zohoDeskUrl}/api/v1/organizationFields?module=${module}`,
        type: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        connectionLinkName: "zohodeskconnector",
        responseType: "json",
      };

      window.ZOHODESK.request(fieldsRequestObj).then(
        (res) => {
          var dataObj = res.data;
          var fieldsObj = dataObj.statusMessage;
          resolve(fieldsObj.data);
        },
        (error) => {}
      );
    });
  },
  saveApplicationToken: function (hashToBeSaved) {
    return new Promise((resolve, reject) => {
      var userId;

      var saveToLocalStorage = async function (hashToBeSaved) {
        try {
          if (!userId) {
            userId = await getUserIdFromZohoDesk();
          }
          var hashKey = `zohodesk_hash_${userId}`;
          localStorage.setItem(hashKey, hashToBeSaved);
          if (!hashToBeSaved) window.localStorage.removeItem(hashKey);
          resolve("");
        } catch (localStorageErr) {
          console.error("ZOHODESK saveApplicationToken - Error saving to localStorage:", localStorageErr);
          resolve("");
        }
      };

      try {
        if (!window?.ZOHODESK?.get || !window?.ZOHODESK?.set) {
          throw new Error("ZOHODESK SDK not available");
        }

        window?.ZOHODESK?.get("user.id")
          .then(function (userResponse) {
          userId = userResponse["user.id"];

          var userHashJson = {};
          userHashJson[userId] = hashToBeSaved;

          var queriableValue = userId + "_hash";
          if (!hashToBeSaved) window.localStorage.removeItem("Omni_zohodesk_userId");
          return window.ZOHODESK.set("database", {
            key: queriableValue,
            value: userHashJson,
            queriableValue: queriableValue,
          });
        })
          .then(function (setResponse) {
          resolve("");
        })
          .catch(function (error) {
            console.error("ZOHODESK saveApplicationToken - Error in promise chain:", error);
            saveToLocalStorage(hashToBeSaved).then(resolve).catch(reject);
          });
      } catch (err) {
        console.error("ZOHODESK saveApplicationToken - SDK not available or error:", err);
        saveToLocalStorage(hashToBeSaved).then(resolve).catch(reject);
      }
    });
  },
  getApplicationToken: function (userId) {
    return new Promise((resolve, reject) => {
      const getFromLocalStorage = function () {
        try {
          var localStorageKey = `zohodesk_hash_${userId}`;
          var storedHash = localStorage.getItem(localStorageKey);
          if (storedHash) {
            resolve(storedHash);
          } else {
            resolve("");
          }
        } catch (localStorageErr) {
          console.error("ZOHODESK getApplicationToken - Error reading from localStorage:", localStorageErr);
          resolve("");
        }
      };

      // Check SDK availability first
      if (!window?.ZOHODESK?.get) {
        console.error("ZOHODESK getApplicationToken - SDK not available or error: ZOHODESK SDK not available");
        getFromLocalStorage();
        return;
      }

      // First get the userId, then fetch from database
      window.ZOHODESK.get("user.id")
        .then(function (userResponse) {
        var userIdFromSDK = userResponse["user.id"];

        var queriableValue = userIdFromSDK + "_hash";

        return window.ZOHODESK.get("database", { queriableValue: queriableValue }).then(function (response) {
          if (!response?.["database.get"]?.data?.length) {
            throw new Error("No data found in response");
          }

          var userHashObjectStoredFromZohoDesk = response["database.get"].data[0].value;

          var userHashJson = {};

          if (typeof userHashObjectStoredFromZohoDesk == "string") {
            try {
              userHashJson = JSON.parse(userHashObjectStoredFromZohoDesk);
            } catch (e) {
              console.error("ZOHODESK getApplicationToken - Error parsing hash data:", e);
              throw new Error("Error parsing hash data");
            }
          } else if (typeof userHashObjectStoredFromZohoDesk == "object") {
            userHashJson = userHashObjectStoredFromZohoDesk;
          }

          if (userHashJson === undefined || userHashJson === "") {
            userHashJson = {};
          }

          if (userIdFromSDK in userHashJson) {
            var hash = userHashJson[userIdFromSDK];
            resolve(hash);
          } else {
            throw new Error("No hash found for userId");
          }
        });
      })
        .catch(function (error) {
          console.error("ZOHODESK getApplicationToken - Error in promise chain:", error);
          getFromLocalStorage();
        });
    });
  },
};
async function fetchContactFromZohoDesk(fetchData, appProperties, phoneFieldConfiguration, ticketObj) {
  try {
    const numbersList = [];
    const {
      primaryPhoneApiName,
      secondaryPhoneApiName,
      secondaryPhoneTwoApiName,
      primaryPhoneLookUp,
      secondaryPhoneLookUp,
      secondaryPhoneTwoLookUp,
    } = phoneFieldConfiguration?.data?.config || {};

    const hasAssociatedModule = primaryPhoneLookUp || secondaryPhoneLookUp || secondaryPhoneTwoLookUp;
    if (hasAssociatedModule) {
      return await getAllAssociatedModulesPhoneRecords(
        primaryPhoneLookUp,
        secondaryPhoneLookUp,
        secondaryPhoneTwoLookUp,
        ticketObj,
        primaryPhoneApiName,
        secondaryPhoneApiName,
        secondaryPhoneTwoApiName,
        numbersList,
        appProperties
      );
    } else {
      return assemblePhoneRecords(ticketObj, primaryPhoneApiName, secondaryPhoneApiName, secondaryPhoneTwoApiName, numbersList);
    }
  } catch (err) {
    console.error("Error in fetchContactFromZohoDesk:", err);
    throw err;
  }
}

function assemblePhoneRecords(recordObj, primaryPhoneApiName, secondaryPhoneApiName, secondaryPhoneTwoApiName, numbersList) {
  const recordInfoObj = { id: recordObj.id, module: "tickets" };

  const phoneFields = [primaryPhoneApiName, secondaryPhoneApiName, secondaryPhoneTwoApiName].filter(Boolean).filter((field) => recordObj[field]);

  if (phoneFields.length > 0) {
    recordInfoObj.phone = recordObj[phoneFields[0]];
    numbersList.push(recordInfoObj);
  }
  return numbersList;
}

async function getAllAssociatedModulesPhoneRecords(
  primaryPhoneLookUp,
  secondaryPhoneLookUp,
  secondaryPhoneTwoLookUp,
  ticketObj,
  primaryPhoneApiName,
  secondaryPhoneApiName,
  secondaryPhoneTwoApiName,
  numbersList,
  appProperties
) {
  try {
    const contactId = ticketObj?.contactId;
    if (!contactId) {
      console.warn("No contactId found in ticket object");
      return numbersList;
    }

    const zohoDeskUrl = appProperties?.zohoDeskUrl ?? "https://desk.zoho.com";

    // Create reusable request configuration
    const createRequestConfig = (url) => ({
      url,
      type: "GET",
      headers: { "Content-Type": "application/json" },
      connectionLinkName: "zohodeskconnector",
      responseType: "json",
    });

    // Fetch contact record
    const contactResponse = await window.ZOHODESK.request(createRequestConfig(`${zohoDeskUrl}/api/v1/contacts/${contactId}`));
    const contactRecord = contactResponse?.data?.statusMessage;

    if (!contactRecord) {
      console.warn("No contact record found");
      return numbersList;
    }

    // Check if we need to fetch account info
    const needsAccountInfo = [primaryPhoneLookUp, secondaryPhoneLookUp, secondaryPhoneTwoLookUp].some((lookup) => lookup === "accountId");

    let accountRecord = null;
    let accountId = null;

    if (needsAccountInfo) {
      accountId = contactRecord.accountId;
      if (accountId) {
        const accountResponse = await window.ZOHODESK.request(createRequestConfig(`${zohoDeskUrl}/api/v1/accounts/${accountId}`));
        accountRecord = accountResponse?.data?.statusMessage;
      }
    }

    // Define phone lookup configurations
    const phoneLookups = [
      { lookup: primaryPhoneLookUp, apiName: primaryPhoneApiName },
      { lookup: secondaryPhoneLookUp, apiName: secondaryPhoneApiName },
      { lookup: secondaryPhoneTwoLookUp, apiName: secondaryPhoneTwoApiName },
    ].filter((item) => item.lookup && item.apiName); // Filter out empty lookups

    // Process phone lookups
    for (const { lookup, apiName } of phoneLookups) {
      let phoneValue = null;
      let recordId = null;

      if (lookup === "accountId" && accountRecord) {
        phoneValue = accountRecord[apiName];
        recordId = accountId;
      } else if (lookup === "contactId" && contactRecord) {
        phoneValue = contactRecord[apiName];
        recordId = contactId;
      }

      if (phoneValue) {
        numbersList.push({
          id: recordId,
          module: "tickets",
          phone: phoneValue,
        });
        return numbersList; // Return immediately when phone found
      }
    }

    return numbersList;
  } catch (error) {
    console.error("Error in getAllAssociatedModulesPhoneRecords:", error);
    return numbersList;
  }
}

export default ZohoDeskEmbedded;

const REGION_MAP = {
  us: {
    name: "USA",
    deskUrl: "https://desk.zoho.com",
  },
  eu: {
    name: "EUROPE",
    deskUrl: "https://desk.zoho.eu",
  },
  ca: {
    name: "CANADA",
    deskUrl: "https://desk.zohocloud.ca",
  },
  in: {
    name: "INDIA",
    deskUrl: "https://desk.zoho.in",
  },
  au: {
    name: "AUSTRALIA",
    deskUrl: "https://desk.zoho.com.au",
  },
  jp: {
    name: "JAPAN",
    deskUrl: "https://desk.zoho.jp",
  },
  sa: {
    name: "SAUDI",
    deskUrl: "https://desk.zoho.sa",
  },
  uk: {
    name: "UK",
    deskUrl: "https://desk.zoho.uk",
  },
};

async function initializeZohoDesk(setAppProperties) {
  try {
    const osyncIdApiKey = "osyncId";
    try {
      const osyncIdFromStorage = await getDataFromLocalStorage(osyncIdApiKey);
    } catch (err) {}

    if (!window?.ZOHODESK?.extension) {
      return {};
    }

    // Fire off SDK loading in parallel
    const onloadPromise = window.ZOHODESK.extension.onload();

    let App = null;
    try {
      App = await promiseWithTimeout(onloadPromise, 3000);
    } catch (err) {}

    // Regardless of timeout, still resolve the real onload later
    onloadPromise
      .then((loadedApp) => {
      if (!loadedApp) return;
      App = loadedApp;

      const currentDomain = App?.meta?.dcType;
      const zohoDeskUrl = REGION_MAP[currentDomain?.toLowerCase()]?.deskUrl || "";

      App.instance.on("click2Call", function (data) {
        const callToNumber = data?.phoneNumber;
        const contextName = data?.context;

        let associatedObjectId = null;
        let associatesObjectType = null;

        if (contextName === "ticket.detail.page") {
          associatedObjectId = data?.caseId;
          associatesObjectType = "tickets";
        } else if (contextName === "contact.detail.page") {
          associatedObjectId = data?.contactId;
          associatesObjectType = "contacts";
        } else if (contextName === "activity.detail.page") {
          associatedObjectId = data?.activityId;
          associatesObjectType = "activities";
        }

        if (callToNumber && setAppProperties) {
          setAppProperties((prev) => ({
            ...prev,
            callerNumber: callToNumber,
            callRecordId: associatedObjectId,
            callRecordModule: associatesObjectType,
            callType: "outbound",
          }));
          ZohoDeskEmbedded.showCallNotification(App, "outbound", setAppProperties);
        }
      });

      if (setAppProperties) {
        setAppProperties((prev) => ({
          ...prev,
          serviceInitialized: true,
          loadedSDK: App,
          zohoDeskUrl,
        }));
      }
    })
      .catch((err) => {});

    // Continue app logic — return empty or partial app object initially
    return App || {};
  } catch (err) {
    return {};
  }
}

async function getDataFromLocalStorage(key) {
  return new Promise((resolve, reject) => {
    const data = window?.localStorage.getItem(key);
    resolve(data);
  });
}
async function getUserIdFromZohoDesk() {
  try {
    const userResponse = await window?.ZOHODESK?.get("user.id");
    const userId = userResponse["user.id"];
    return userId || getDataFromLocalStorage("Omni_zohodesk_userId");
  } catch (err) {
    return getDataFromLocalStorage("Omni_zohodesk_userId");
  }
}
async function getUserDataFromLocalStorage() {
  const portalIdKey = "Omni_zohodesk_portalId";
  const portalNameKey = "Omni_zohodesk_portalName";
  const userIdKey = "Omni_zohodesk_userId";
  const domainNameKey = "Omni_zohodesk_domainName";
  const userData = {};

  try {
    // Fetch all keys in parallel
    const [portalIdFromStorage, portalNameFromStorage, userIdFromStorage, domainNameFromStorage] = await Promise.all([
      getDataFromLocalStorage(portalIdKey),
      getDataFromLocalStorage(portalNameKey),
      getUserIdFromZohoDesk(userIdKey),
      getDataFromLocalStorage(domainNameKey),
    ]);

    // If portalId is missing, fallback to getCompanyDataFromZohoDesk
    if (portalIdFromStorage === null) {
      return await getCompanyDataFromZohoDesk();
    }

    userData.companyId = portalIdFromStorage;
    userData.companyOrgId = portalNameFromStorage;
    userData.userId = userIdFromStorage;
    userData.domainName = domainNameFromStorage;
    userData.product = "Omni";

    return userData;
  } catch (err) {
    // On any error, fallback to getCompanyDataFromZohoDesk
    return await getCompanyDataFromZohoDesk();
  }
}

async function getCompanyDataFromZohoDesk() {
  try {
    // Get portal data
    const portalResponse = await window?.ZOHODESK?.get("portal");
    const portalObj = portalResponse["portal"];
    // Get user ID
    const userResponse = await window?.ZOHODESK?.get("user.id");
    const userId = userResponse["user.id"];
    // Prepare data
    const userData = {
      companyId: portalObj.id,
      companyOrgId: portalObj.name,
      userId: userId,
      product: "Omni",
      domainName: portalObj.customDomainName,
    };
    // Save to localStorage
    const dataToBeSaved = {
      portalId: portalObj.id,
      portalName: portalObj.name,
      userId: userId,
      domainName: portalObj.customDomainName,
    };
    await saveDataToLocalStorage(dataToBeSaved);
    return userData;
  } catch (err) {
    throw err; // Re-throw to allow caller to handle
  }
}

function saveDataToLocalStorage(data) {
  // No need for a Promise wrapper since this is synchronous
  Object.entries(data).forEach(([key, val]) => {
    if (val !== undefined) {
      window?.localStorage.setItem(`Omni_zohodesk_${key}`, val);
    }
  });
  return Promise.resolve(); // For backward compatibility
}
function promiseWithTimeout(promise, ms) {
  return Promise.race([promise, new Promise((_, reject) => setTimeout(() => reject(new Error("APP_INSTANCE Timeout reached")), ms))]);
}